<template>
  <v-container
    id="cont-cuaderno"
    :style="{ height: imgHeight + 'px' }"
    class="zoom"
    :class="colorCuaderno"
  >
    <!-- note for today -->
    <mdd-pagina-cuaderno-hoy
      @goday="goDay"
      :user-note="userNoteToday"
    ></mdd-pagina-cuaderno-hoy>
    <mdd-cuaderno-resumen-dia
      v-for="(dia, index) in dias"
      :dias-desde-hoy="index + 1"
      :dia="dia"
      :key="dia"
      :user-note="notas[dia] || null"
      @goday="goDay"
    >
    </mdd-cuaderno-resumen-dia>
    <mdd-cargar-mas
      v-show="!llegoaPrimerDia"
      @cargar="cargarMas"
      :color-name="colorName"
      :primer-dia="llegoaPrimerDia"
    ></mdd-cargar-mas>
  </v-container>
</template>

<script>
import mixAppConfig from "../../mixs/mixAppConfig.js";
import mixUserConfig from "../../mixs/mixUserConfig.js";
import mixUserColor from "../../mixs/mixUserColor.js";
import MddPaginaCuadernoHoy from "../cuaderno/MddPaginaCuadernoHoy";
import MddCuadernoResumenDia from "../cuaderno/MddCuadernoResumenDia";
import MddCargarMas from "../cuaderno/MddCargarMas";

export default {
  name: "mdd-portada-cuaderno",
  components: { MddPaginaCuadernoHoy, MddCuadernoResumenDia, MddCargarMas },
  props: ["infooHoy"],
  mixins: [mixAppConfig, mixUserConfig, mixUserColor],
  mounted() {
    this.generarDiasAntes();
  },
  data() {
    return {
      dias: [],
      cant: 10, // cantidad de dias cargados en cada solicitud
      llegoaPrimerDia: false,
      ultimoDia: null
    };
  },
  computed: {
    appSizes() {
      return this.$store.getters["app/sizes"];
    },
    imgHeight() {
      return this.$vuetify.breakpoint.height - this.$vuetify.application.top;
    },
    userAuth() {
      return this.$store.getters["user/auth"];
    },
    userNoteToday() {
      return this.$store.getters["user/notes/item"](this.infooHoy.iso);
    },
    notas() {
      return this.$store.getters["user/notes/items"];
    }
  },
  methods: {
    cargarMas() {
      this.cant = this.cant < 30 ? (this.cant = this.cant + 10) : this.cant;
      this.generarDiasAntes();
    },
    generarDiasAntes() {
      if (this.llegoaPrimerDia) return;
      // payload {fecha, cant}
      // fMinima por defecto el lanzamiento de la app
      const fMinima = this.userAuth.created || "2020-05-01";

      const diaAntes = function(dia) {
        let arr = dia.split("-");
        let fechaDia = new Date(arr[0], arr[1] - 1, arr[2], 0, 0, 0, 0);
        let fechaAnt = new Date(fechaDia.getTime() - 24 * 60 * 60 * 1000);
        return fechaAnt.toISOString().slice(0, 10);
      };

      var fechaDoc = this.ultimoDia
        ? this.ultimoDia
        : diaAntes(this.infooHoy.iso);

      var aaDocs = [];

      for (let i = 0; i < this.cant; i++) {
        if (fechaDoc < fMinima) {
          // no hay mas
          this.llegoaPrimerDia = true;
          this.ultimoDia = fechaDoc;
          this.$store.dispatch("user/notes/getLocalDocs", aaDocs);
          return;
        } else {
          this.dias.push(fechaDoc);
          aaDocs.push(fechaDoc);
        }
        fechaDoc = diaAntes(fechaDoc);
      }

      this.ultimoDia = fechaDoc;
      this.$store.dispatch("user/notes/getLocalDocs", aaDocs);
    },
    goDay(dia) {
      let params = {
        anio: dia.anio,
        mes: dia.mes,
        dia: dia.dia
      };
      this.$router.push({ name: "MddCuadernoDia", params: params }).catch(e => {
        this.$store.dispatch("app/saveErrorReport", {
          e: e,
          line: 91,
          src: "mdd-portada-cuaderno"
        });
      });
    }
  }
};
</script>

<style>
#cont-cuaderno {
  overflow-y: scroll;
}
</style>
